import { environmentMarkLabel, PRODUCTION_APP_URL } from "@/lib/environment";
import { EnvironmentBadge } from "./EnvironmentBadge";

/**
 * Prominent notice above the sign-in form outside production (#1099): the
 * last moment to notice the wrong environment before working in it.
 */
export const EnvironmentLoginNotice = () => {
  const label = environmentMarkLabel();
  if (!label) {
    return null;
  }
  return (
    <div
      role="note"
      aria-label={`${label} environment`}
      className="mx-auto flex max-w-2xl items-start gap-3 rounded-lg border-2 border-amber-500 bg-amber-100 p-4 text-amber-950 shadow-xl"
    >
      <EnvironmentBadge className="px-2.5 py-1 text-base" />
      <div className="space-y-1 text-sm">
        <p className="font-bold">You are signing in to the {label} test environment.</p>
        <p>
          Data here is not real and is reset on every deploy. To work with real consultants, sign in
          on PROD at {/* 24px tap target (#1038) without moving the text. */}
          <a
            href={PRODUCTION_APP_URL}
            className="-mx-1 -my-1 inline-block px-1 py-1 font-semibold underline underline-offset-2 hover:text-amber-800"
          >
            app.bondit.dk
          </a>
          .
        </p>
      </div>
    </div>
  );
};
